import type { MessageInstance } from 'antd/es/message/interface'

let messageApi: MessageInstance | null = null

export const setMsg = (api: MessageInstance) => {
  messageApi = api
}

export const msg = (): MessageInstance => {
  if (!messageApi) {
    throw new Error('messageApi 未初始化，请确保 App 组件已挂载')
  }
  return messageApi
}
